// KooTube のロゴマーク: 角の丸まった再生三角。
// stroke で外周をふくらませて角を round にすることで、path 側は素の三角のままきれいな角丸になる。
export function Logo({
  size = 20,
  color = 'var(--brand)',
}: {
  size?: number;
  color?: string;
}): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M9 5.5 L18 12 L9 18.5 Z"
        fill={color}
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
